import { Alert } from '@f_general/alert';
import { TFunction } from 'i18next';

export const headerUserCopyReferralLinkUtil = async (
    url: string | null,
    t: TFunction<'translation', undefined>,
): Promise<void> => {
    const errorMessage = t('common.referral.copy_failed');
    const successMessage = t('common.referral.copy_success');

    try {
        if (!url) throw new Error('URL is not found');

        await navigator.clipboard.writeText(url);

        Alert({
            type: 'success',
            text: successMessage,
            time: 6000,
        });
    } catch {
        Alert({
            type: 'error',
            text: errorMessage,
            time: 6000,
        });
    }
};
